import {Component, EventEmitter, Input, Output} from '@angular/core';

import {SmNavMenuItemModel} from './sm-nav-menu-item-model';
import {SmNavMenuItemTone} from './sm-nav-menu-item-tone';
export type {SmNavMenuItemModel} from './sm-nav-menu-item-model';
export type {SmNavMenuItemTone} from './sm-nav-menu-item-tone';

@Component({
  selector: 'sm-nav-menu-item',
  templateUrl: './sm-nav-menu-item.component.html',
  styleUrls: ['./sm-nav-menu-item.component.scss'],
  standalone: false,
})
export class SmNavMenuItemComponent {
  @Input({required: true}) item!: SmNavMenuItemModel;
  @Input() level: 1 | 2 = 1;
  @Input() selected = false;
  @Input() expanded = false;
  @Input() ariaCurrent: 'page' | null = null;

  @Output() itemClick = new EventEmitter<SmNavMenuItemModel>();

  get hasChildren(): boolean {
    return Boolean(this.item.children?.length);
  }

  get isDisabled(): boolean {
    return Boolean(this.item.disabled);
  }

  getToneStyles(_tone: SmNavMenuItemTone | undefined): Record<string, string> {
    switch (_tone ?? 'slate') {
      case 'amber':
        return {
          '--item-bg-active': 'rgba(214, 228, 246, 0.96)',
          '--item-text': '#2f4e7c',
          '--item-icon-bg': 'transparent',
          '--item-icon-color': '#18355a',
          '--item-badge-bg': 'var(--ap-info-normal-background, #c7daf3)',
          '--item-badge-text': 'var(--ap-info-normal-text, #355d9d)',
        };
      case 'orange':
        return {
          '--item-bg-active': 'rgba(214, 228, 246, 0.96)',
          '--item-text': '#2f4e7c',
          '--item-icon-bg': 'transparent',
          '--item-icon-color': '#18355a',
          '--item-badge-bg': 'var(--ap-warning-normal-background, #f6e0c8)',
          '--item-badge-text': 'var(--ap-warning-normal-text, #b46a1c)',
        };
      case 'red':
        return {
          '--item-bg-active': 'rgba(214, 228, 246, 0.96)',
          '--item-text': '#2f4e7c',
          '--item-icon-bg': 'transparent',
          '--item-icon-color': '#18355a',
          '--item-badge-bg': 'var(--ap-error-normal-background, #f2d8d7)',
          '--item-badge-text': 'var(--ap-error-normal-text, #b14b46)',
        };
      case 'slate':
      default:
        return {
          '--item-bg-active': 'rgba(214, 228, 246, 0.96)',
          '--item-text': '#2f4e7c',
          '--item-icon-bg': 'transparent',
          '--item-icon-color': '#18355a',
          '--item-badge-bg': 'var(--ap-info-normal-background, #d9e6f7)',
          '--item-badge-text': 'var(--ap-info-normal-text, #355d9d)',
        };
    }
  }

  handleClick(): void {
    if (this.isDisabled) {
      return;
    }

    this.itemClick.emit(this.item);
  }

  handleLinkClick(event: MouseEvent): void {
    if (this.isDisabled) {
      event.preventDefault();
      return;
    }

    if (this.item.externalHref && this.item.externalNative) {
      event.preventDefault();
      this.itemClick.emit(this.item);
      return;
    }

    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
      return;
    }

    this.itemClick.emit(this.item);
  }

  handleGroupKeydown(event: Event): void {
    if (this.isDisabled || !this.hasChildren) {
      return;
    }

    event.preventDefault();
    this.itemClick.emit(this.item);
  }

  trackById(_: number, item: SmNavMenuItemModel): string {
    return item.id;
  }
}
